import { Card } from "antd";
import { Text, Affix } from "@mantine/core";





const Footer = () => {
    return (
        <>
            <Affix position={{ bottom: 2, right: 2}}>
                <Card style={{backgroundColor: 'black', borderRadius: '25px'}}>
                    <Text c="dimmed" size="sm">
                        © 2025- {new Date().getFullYear()}  Court Date Reminder. All rights reserved.
                    </Text>
                    <Text c="dimmed" size="xs">
                        Design & Developed by <a href="https://gvinfotech.netlify.app" target="_blank" rel="noreferrer">GV InfoTech</a>
                    </Text>
                </Card>
            </Affix>

        </>
    )
}
export default Footer;